
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:599)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}}),_c('path',{attrs:{"d":"M30.45 24.25a4.999 4.999 0 01-1.82 2.703A5.185 5.185 0 0125.5 28a5.185 5.185 0 01-3.13-1.047 4.999 4.999 0 01-1.82-2.702H14v-2.502h6.55a4.999 4.999 0 011.82-2.702A5.185 5.185 0 0125.5 18c1.133 0 2.234.368 3.13 1.047a4.999 4.999 0 011.82 2.702H37v2.502h-6.55z","fill":"#CCC"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:599","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:599"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:599","result":"shape"}})])])])
          )
        }
      }
    